import { userDetails } from "../store/IntialStore";
import * as types from "../action/ActionType";
import type { AppAction, UserDetails } from "../action/ActionType";

export default function UserReducer(
  state: UserDetails = userDetails,
  action: AppAction
): UserDetails {
  switch (action.type) {
    case types.ADD_USER_PROFILE:
      return action.payload;
    case types.UPDATE_USER_PROFILE:
      return { ...userDetails, profilePic: action.payload, userName: action.userName };
    default:
      return state;
  }
}
